import { Module } from 'vuex-smart-module';
import BrandsActions from './actions';
import BrandsGetters from './getters';
import BrandsMutations from './mutations';
import BrandsState from './state';

export default new Module({
  state: BrandsState,
  mutations: BrandsMutations,
  actions: BrandsActions,
  getters: BrandsGetters,
});
